// extracted by mini-css-extract-plugin
module.exports = {"profileAvatar":"_boardSlug__profileAvatar__xoQuH","index":"_boardSlug__index__AdKKg","score":"_boardSlug__score__2bxjo","colTitle":"_boardSlug__colTitle__gbnfc"};